/** 電話番号（半角数字10桁または11桁）の形式エラーメッセージ */
export const PHONE_TEL_FORMAT_MESSAGE =
	'電話番号は半角数字10桁または11桁で入力してください。';

const PHONE_TEL_RE = /^\d{10,11}$/;

/**
 * @param {string} value
 * @returns {boolean}
 */
export function isValidPhoneTel(value) {
	if (typeof value !== 'string') return false;
	return PHONE_TEL_RE.test(value.trim());
}
